import { render, staticRenderFns } from "./productAnalysis.vue?vue&type=template&id=040eb77e&scoped=true&"
import script from "./productAnalysis.vue?vue&type=script&lang=js&"
export * from "./productAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./productAnalysis.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./productAnalysis.vue?vue&type=style&index=1&id=040eb77e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040eb77e",
  null
  
)

component.options.__file = "productAnalysis.vue"
export default component.exports